import { imgUploadToCloud } from "services/category";

const multiImgUploadToCloudFun = async (propData) => {
  // console.log(propData.length, "propData");
  const formData = new FormData();

  for (let i = 0; i < propData.length; i++) {
    formData.append("images", propData[i]);
  }

  const {
    data: { data },
    status,
    code,
  } = await imgUploadToCloud(formData);

  // console.log(" status,code", status, code);

  const cloudData = {
    data,
    status,
    code,
  };
  return cloudData;
};

export default multiImgUploadToCloudFun;
